var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrivenMediaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_28836",
    "data-name": "Group 28836",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116.521,
    height: 17.634,
    viewBox: "0 0 116.521 17.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3676",
    "data-name": "Rectangle 3676",
    width: 116.521,
    height: 17.634,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27704",
    "data-name": "Group 27704",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56796",
    "data-name": "Path 56796",
    d: "M509.432,8.976c-.209.985-.422,1.968-.627,2.954-.535,2.581-1.054,5.165-1.6,7.743a2.705,2.705,0,0,1-4.032,2.042,2.737,2.737,0,0,1-1.338-1.963q-1.076-5.129-2.158-10.256c-.038-.179-.1-.351-.157-.527l-.17.013c-.085.657-.179,1.312-.253,1.97q-.555,4.913-1.1,9.828a1.519,1.519,0,0,1-1.521,1.409,1.5,1.5,0,0,1-1.7-1.255,8.615,8.615,0,0,1,.116-2.018c.5-3.681.994-7.364,1.565-11.035a2.827,2.827,0,0,1,3.821-2.37,2.741,2.741,0,0,1,1.94,2.237c.463,2.125.877,4.26,1.309,6.392q.439,2.161.872,4.323l.157.03a2.17,2.17,0,0,0,.176-.414q.966-4.846,1.925-9.694a7.516,7.516,0,0,1,.292-1.1,2.724,2.724,0,0,1,2.869-1.9A2.567,2.567,0,0,1,512.4,7.391a32.087,32.087,0,0,1,.59,3.42c.441,3.024.857,6.052,1.3,9.076.168,1.159-.215,1.95-1.122,2.223a1.568,1.568,0,0,1-2.128-1.3c-.214-1.543-.369-3.095-.546-4.643q-.38-3.335-.757-6.67a4.241,4.241,0,0,0-.12-.507l-.18-.008",
    transform: "translate(-435.35 -4.713)",
    fill: "#a4348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56797",
    "data-name": "Path 56797",
    d: "M0,15.163c0-2.1-.007-4.2,0-6.3C.01,7.694.606,6.933,1.748,6.92a39.666,39.666,0,0,1,5.915.2,6.241,6.241,0,0,1,5.5,5.712,14.526,14.526,0,0,1-.1,5.184A6.6,6.6,0,0,1,6.431,23.4c-1.517.062-3.038.043-4.557.022A1.792,1.792,0,0,1,.005,21.46c-.01-2.1,0-4.2,0-6.3m2.6,5.725c1.31,0,2.592.078,3.862-.017,2.337-.175,3.786-1.382,4.118-3.618a15.562,15.562,0,0,0,.018-4.225A3.743,3.743,0,0,0,7.216,9.58C5.707,9.368,4.162,9.414,2.6,9.344Z",
    transform: "translate(0 -6.073)",
    fill: "#040404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56798",
    "data-name": "Path 56798",
    d: "M890.374,44.267c.28-1.529-.348-2.36-1.836-2.337a18.244,18.244,0,0,0-2.362.314c-.275.041-.544.143-.82.16a1.331,1.331,0,0,1-1.491-.937,1.394,1.394,0,0,1,.746-1.716,6.475,6.475,0,0,1,2.169-.611,15.392,15.392,0,0,1,3.741.2,3.442,3.442,0,0,1,2.873,3.284c.166,2.329.111,4.675.125,7.013a1.337,1.337,0,0,1-.747,1.155,9.063,9.063,0,0,1-5.245,1.152,5.039,5.039,0,0,1-2.978-.958,3.8,3.8,0,0,1-1.4-4.173,3.509,3.509,0,0,1,3.252-2.684,21.064,21.064,0,0,1,3.273.032,5.307,5.307,0,0,1,.7.11m.074,3.333a5.258,5.258,0,0,0-.012-.775c-.018-.121-.15-.313-.245-.322a18.063,18.063,0,0,0-2.831-.2,1.423,1.423,0,0,0-.018,2.822,6.065,6.065,0,0,0,1.827,0c1.19-.178,1.279-.33,1.278-1.529",
    transform: "translate(-776.999 -34.415)",
    fill: "#a5348b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56799",
    "data-name": "Path 56799",
    d: "M307.221,46.2a2.757,2.757,0,0,0,3.248,3.17,15.419,15.419,0,0,0,2.382-.542c.825-.235,1.428-.076,1.693.532a1.2,1.2,0,0,1-.793,1.628,7.574,7.574,0,0,1-5.884.285,4.643,4.643,0,0,1-3.106-4.187,17.481,17.481,0,0,1,.059-4.055,5.05,5.05,0,0,1,5.43-4.269c3.176.144,5.441,2.365,5,6.327a1.232,1.232,0,0,1-1.394,1.109c-2.019.007-4.039,0-6.058,0h-.578m-.02-1.961c1.683,0,3.337-.018,4.99.01.545.009.7-.2.666-.708a2.661,2.661,0,0,0-3.138-2.519,2.691,2.691,0,0,0-2.517,3.216",
    transform: "translate(-268.095 -34.105)",
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56800",
    "data-name": "Path 56800",
    d: "M400.636,45.522c0-1.48.012-2.959-.006-4.439a1.257,1.257,0,0,1,.675-1.235,8.6,8.6,0,0,1,7.322-.668,3.72,3.72,0,0,1,2.448,3.54c.119,2.474.085,4.955.078,7.434a1.223,1.223,0,0,1-1.257,1.316,1.3,1.3,0,0,1-1.255-1.395c-.008-1.86-.065-3.722.012-5.578.122-2.944-1.491-3.638-3.874-3.307-.039.005-.079.013-.118.021-1.437.278-1.5.352-1.5,1.789,0,2.359,0,4.719,0,7.079a1.289,1.289,0,0,1-1.076,1.378,1.256,1.256,0,0,1-1.337-.793,2.046,2.046,0,0,1-.1-.7c-.009-1.48,0-2.959,0-4.439",
    transform: "translate(-352.534 -34.01)",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56801",
    "data-name": "Path 56801",
    d: "M216.667,49.977c.482-1.384.921-2.638,1.357-3.893q.852-2.457,1.7-4.915a1.358,1.358,0,0,1,1.094-1.064,1.3,1.3,0,0,1,1.4,1.863c-.769,2.1-1.564,4.181-2.347,6.271-.342.914-.663,1.837-1.023,2.745a2.279,2.279,0,0,1-2.134,1.72,2.25,2.25,0,0,1-2.294-1.743c-.853-2.255-1.683-4.519-2.523-6.779-.278-.747-.565-1.491-.832-2.242a1.32,1.32,0,0,1,.667-1.807,1.289,1.289,0,0,1,1.759.952c.991,2.8,1.969,5.6,2.954,8.4.043.122.106.237.221.488",
    transform: "translate(-185.627 -35.225)",
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56802",
    "data-name": "Path 56802",
    d: "M120.32,46.6c0,1.2,0,2.4,0,3.6a1.264,1.264,0,1,1-2.518.01c-.008-2.54-.022-5.08,0-7.619a3.6,3.6,0,0,1,4.094-3.8,14.059,14.059,0,0,1,1.78.217c.873.162,1.315.723,1.189,1.435-.132.745-.688,1.074-1.591.941-.355-.052-.708-.132-1.065-.156a1.566,1.566,0,0,0-1.885,1.708c-.025,1.219-.005,2.44-.006,3.66",
    transform: "translate(-103.649 -34.13)",
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56803",
    "data-name": "Path 56803",
    d: "M856.84,45.283c0,1.539,0,3.078,0,4.617a1.6,1.6,0,0,1-1.552,1.76,1.625,1.625,0,0,1-1.6-1.737q-.017-4.677,0-9.354a1.58,1.58,0,0,1,1.6-1.722,1.6,1.6,0,0,1,1.557,1.76c0,1.559,0,3.118,0,4.677",
    transform: "translate(-751.194 -34.182)",
    fill: "#a4338a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56804",
    "data-name": "Path 56804",
    d: "M184.513,46.732c0,1.637,0,3.275,0,4.912a1.262,1.262,0,0,1-1.241,1.385,1.291,1.291,0,0,1-1.259-1.389q-.008-4.942,0-9.884a1.212,1.212,0,0,1,1.279-1.333,1.23,1.23,0,0,1,1.219,1.337c.005,1.657,0,3.315,0,4.972",
    transform: "translate(-160.158 -35.57)",
    fill: "#040404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56805",
    "data-name": "Path 56805",
    d: "M856.224,1.706a1.682,1.682,0,1,1-3.362-.04,1.681,1.681,0,1,1,3.362.04",
    transform: "translate(-750.475 0)",
    fill: "#a5368c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56806",
    "data-name": "Path 56806",
    d: "M180.69,4.8a1.4,1.4,0,1,1,2.8.069,1.4,1.4,0,1,1-2.8-.069",
    transform: "translate(-158.998 -3.011)",
    fill: "#040404"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56807",
    "data-name": "Path 56807",
    d: "M784.02,66.961c0,.78-.023,1.56.01,2.338a.63.63,0,0,1-.469.723,7.875,7.875,0,0,1-1.551.413c-1.7.152-2.568-.562-2.7-2.266a16.038,16.038,0,0,1,.042-2.745,1.876,1.876,0,0,1,1.785-1.792,4.205,4.205,0,0,1,1.016,0c1.715.191,1.87.37,1.87,2.072v1.259",
    transform: "translate(-685.715 -55.965)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56808",
    "data-name": "Path 56808",
    d: "M21.64,38.79V27.245c1.564.07,3.109.024,4.618.236a3.743,3.743,0,0,1,3.38,3.449,15.562,15.562,0,0,1-.018,4.225c-.333,2.236-1.781,3.443-4.118,3.618-1.269.095-2.551.017-3.862.017",
    transform: "translate(-19.042 -23.974)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56809",
    "data-name": "Path 56809",
    d: "M913.205,100.228c0,1.2-.088,1.35-1.279,1.529a6.065,6.065,0,0,1-1.827,0,1.423,1.423,0,0,1,.018-2.822,18.066,18.066,0,0,1,2.831.2c.1.01.227.2.245.322a5.334,5.334,0,0,1,.012.775",
    transform: "translate(-799.756 -87.044)",
    fill: "#fdfcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56810",
    "data-name": "Path 56810",
    d: "M325.608,60.771a2.691,2.691,0,0,1,2.517-3.216,2.661,2.661,0,0,1,3.138,2.519c.031.508-.12.717-.666.708-1.653-.028-3.308-.01-4.99-.01",
    transform: "translate(-286.502 -50.634)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56811",
    "data-name": "Path 56811",
    d: "M665.707,46.207c-.318,1.308.74,2.809,2.768,2.569a15.417,15.417,0,0,0,2.382-.542,1.592,1.592,0,0,1,1.933.652,1.886,1.886,0,0,1-1.033,2.109,7.573,7.573,0,0,1-5.884.285,4.6,4.6,0,0,1-3.3-4,17.474,17.474,0,0,1,.059-4.055,5.4,5.4,0,0,1,5.624-4.457c3.176.144,5.561,2.365,5.122,6.327-.08.719-.708,1.106-1.514,1.109-2.019.007-4.038,0-6.058,0h-.1m-.14-2.081c1.682,0,2.5-.018,4.15.01.545.009.7-.079.666-.588a2.172,2.172,0,0,0-2.538-2.159,2.435,2.435,0,0,0-2.277,2.736",
    transform: "translate(-582.951 -34.11)",
    fill: "#a4338a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56812",
    "data-name": "Path 56812",
    d: "M763.648,5.743a1.546,1.546,0,0,0-1.564-1.731,1.589,1.589,0,0,0-1.574,1.737c0,.956,0,1.913,0,2.933a6.587,6.587,0,0,0-5.3-.007,4.753,4.753,0,0,0-2.645,4.384c-.041.842-.018,2.532.039,3.373a4.827,4.827,0,0,0,3.871,4.442,8.677,8.677,0,0,0,6.448-1.132,1.4,1.4,0,0,0,.73-1.335c-.015-4.221-.007-8.442-.009-12.663m-3.6,11.844A7.869,7.869,0,0,1,758.5,18c-1.7.152-2.568-.562-2.7-2.266a16.05,16.05,0,0,1,.042-2.745,1.876,1.876,0,0,1,1.785-1.792,4.205,4.205,0,0,1,1.016,0c1.715.191,1.87.37,1.87,2.072v1.259c0,.78-.023,1.56.009,2.338a.629.629,0,0,1-.468.723",
    transform: "translate(-662.205 -3.53)",
    fill: "#a4338a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivenMediaLogo);
export default __webpack_public_path__ + "static/media/driven-media-logo.5cfb0433aff4b47e90a19fbafbc8908e.svg";
export { ForwardRef as ReactComponent };